import { PreAuth } from '@/components/PreAuth/PreAuth';
import { Alert, Box, Button, PasswordInput } from '@mantine/core';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/AuthProvider';
import { IconLock } from '@tabler/icons-react';
import { useState } from 'react';
import { postFetcher } from '@/api/fetchers';
import { notifications } from '@mantine/notifications';
import { displayError } from '@/utils/error/errorHandler';

export const PasswordResetPage = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlToken = queryParams.get('token');
  const [formData, setFormData] = useState({
    newPassword: '',
    newPasswordRepeat: '',
  });

  const [newPasswordError, setNewPasswordError] = useState('');
  const [repeatNewPasswordError, setRepeatNewPasswordError] = useState('');

  const { token } = useAuth();

  if (token) {
    return <Navigate to="/my-account" />;
  }

  const successfullyChangedPasswordNotification = () => {
    notifications.show({
      color: 'green',
      title: 'Úspěch!',
      message: 'Přihlaste se novým heslem',
      radius: 'md',
      autoClose: 4000,
      style: { backgroundColor: '#d9ffde' },
    });
  };

  const icon = <IconLock />;

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    // to prevent instant refresh to show errors
    event.preventDefault();

    setNewPasswordError('');
    setRepeatNewPasswordError('');
    let hasError = false;

    if (
      formData.newPassword === null ||
      formData.newPassword === undefined ||
      formData.newPassword === ''
    ) {
      setNewPasswordError('Toto pole je povinné');
      hasError = true;
    }

    if (
      formData.newPasswordRepeat === null ||
      formData.newPasswordRepeat === undefined ||
      formData.newPasswordRepeat === ''
    ) {
      setRepeatNewPasswordError('Toto pole je povinné');
      hasError = true;
    }

    if (formData.newPassword !== formData.newPasswordRepeat) {
      setRepeatNewPasswordError('Hesla nejou stejná');
      hasError = true;
    }

    if (hasError) return;

    try {
      const code = await postFetcher('/auth/password-change', {
        token: urlToken,
        newPassword: formData.newPassword,
      });
      successfullyChangedPasswordNotification();
      navigate('/login');
    } catch (err) {
      displayError(err);
      navigate('/login/forgot-password');
    }
  };

  return (
    <PreAuth>
      <Box className="flex flex-col justify-center items-center w-full pt-12 pb-24">
        <Alert
          maw="30rem"
          variant="transparent"
          color="blue"
          title="Změna hesla"
          icon={icon}
          className="w-full"
          radius="md"
        >
          Pozor, tento odkaz platí jenom 30 minut po odesílání.
        </Alert>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col justify-center items-center w-full gap-4"
        >
          <PasswordInput
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            error={newPasswordError}
            radius="md"
            size="md"
            variant="filled"
            maw="25rem"
            placeholder="Nové heslo"
            className="w-full"
          />
          <PasswordInput
            name="newPasswordRepeat"
            value={formData.newPasswordRepeat}
            onChange={handleChange}
            error={repeatNewPasswordError}
            radius="md"
            size="md"
            variant="filled"
            maw="25rem"
            placeholder="Zopakujte nové heslo"
            className="w-full"
          />
          <Button
            maw="25rem"
            size="md"
            radius="md"
            type="submit"
            className="w-full text-lg"
          >
            Potvrdit
          </Button>
        </form>
      </Box>
    </PreAuth>
  );
};
